import { NgModule } from '@angular/core';
import { FcSearchInputModule } from '@core/components/fc-input/base/fc-search-input/fc-search-input.module';
import { TranslateModule } from '@ngx-translate/core';
import { LocationsGroupsComponent } from './locations-groups.component';


@NgModule({
  declarations: [
    LocationsGroupsComponent
  ],
  imports: [
    FcSearchInputModule,
    TranslateModule
  ],
  exports: [
    LocationsGroupsComponent
  ]
})

export class LocationsGroupsComponentModule {}
